export const IP_LOCKED_ERROR_CODE = 'iplock.rest.routes.user.session.providerinfo_v1_1.bad_request';
export const IP_LOCKED = 'IP locked';

export const isIpLock = (errorCode: string, options: { statusCode: number }) => {
    return options.statusCode === 403 && errorCode === IP_LOCKED_ERROR_CODE;
};
